import * as React from 'react';
import { Segment, Table as UITable } from 'semantic-ui-react';
export var Packages = function (_a) {
    var detail = _a.detail, children = _a.children;
    return (<div data-testid={detail.type}>
		{children}
		<Segment.Group compact>
			<UITable striped unstackable size='small'>
				<UITable.Header>
					<UITable.Row>
						<UITable.HeaderCell data-testid='record-header'>Lečivý přípravek</UITable.HeaderCell>
						<UITable.HeaderCell data-testid='record-header'>Doplněk</UITable.HeaderCell>
						<UITable.HeaderCell data-testid='record-header'>SUKL kód</UITable.HeaderCell>
					</UITable.Row>
				</UITable.Header>
				<UITable.Body>
					{detail.records.map(function (record, i) { return (<UITable.Row data-testid='record' key={i}>
							<UITable.Cell>{record.brand}</UITable.Cell>
							<UITable.Cell>{record.supplement}</UITable.Cell>
							<UITable.Cell>{record.suklCode}</UITable.Cell>
						</UITable.Row>); })}
				</UITable.Body>
			</UITable>
		</Segment.Group>
	</div>);
};
